// extracted by mini-css-extract-plugin
export default {"centredOnScreen":"styles_centredOnScreen__a8M4E"};